import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class AlertService {
  constructor(
    private readonly toastr: ToastrService,
    private readonly translateService: TranslateService
  ) {}

  private interpolateName(
    msg: string,
    prefix?: string,
    suffix?: string
  ): string {
    let result = msg;

    // Replace {name}
    if (prefix) {
      result = result.replaceAll('{name}', prefix);
    } else {
      result = result.replaceAll(/\{name\}\s*(\w?)/g, (_match, nextChar) =>
        nextChar ? nextChar.toUpperCase() : ''
      );
    }

    // Replace {name2}
    if (suffix) {
      result = result.replaceAll('{name2}', suffix);
    } else {
      result = result.replaceAll(/\s*\{name2\}/g, ''); // just remove safely
    }

    return result;
  }

  private buildMessage(
    message: string,
    prefix: string,
    suffix: string
  ): string {
    let msg = this.translateService.instant(message);
    msg = this.interpolateName(msg, prefix, suffix);
    if (prefix && !msg.includes(prefix) && !msg.includes('{name}')) {
      msg = `${prefix} ${msg}`;
    }
    if (suffix && !msg.includes(suffix) && !msg.includes('{name2}')) {
      msg = `${msg} ${suffix}`;
    }
    return msg;
  }

  success(
    message: string,
    title: string = 'Success',
    prefix: string = '',
    suffix: string = ''
  ): void {
    this.toastr.success(this.buildMessage(message, prefix, suffix), title);
  }

  error(
    message: string,
    title: string = 'Error',
    prefix: string = '',
    suffix: string = ''
  ): void {
    this.toastr.error(this.buildMessage(message, prefix, suffix), title);
  }

  info(
    message: string,
    title: string = 'Info',
    prefix: string = '',
    suffix: string = ''
  ): void {
    this.toastr.info(this.buildMessage(message, prefix, suffix), title);
  }

  warning(
    message: string,
    title: string = 'Warning',
    prefix: string = '',
    suffix: string = ''
  ): void {
    this.toastr.warning(this.buildMessage(message, prefix, suffix), title);
  }
}
